function setupProductCarousel() {
  var elem = document.querySelector('.product-slider__content');
    var flkty = new Flickity(elem, {
      cellAlign: 'left',
      contain: true,
      draggable: '>1',
      wrapAround: false,
      setGallerySize: false,
      pageDots: true,
      prevNextButtons: true,
    });

    var flkty = new Flickity('.slider-wrapper', {
    });
}

function setPricesVariants() {
    (function($) {
      var comparePrice = $('.variant-compare-price');
      // var comparePrice = $('.product-compare-at-price');
      var regularPrice = $('.product-regular-price');
      var splittedPrice = $('.product-regular-price-splitted');
      var variantOptions = $('.product-variant-selector');

      if ( variantOptions.length ) {
          variantOptions.on('change', function() {
              var cPrice = $(this).find(":selected").attr("data-compare-price").slice(0,-3);
              var rPrice = $(this).find(":selected").attr("data-regular-price").slice(0,-3);

              
              if (Number(cPrice.slice(3).replace('.', '')) > Number(rPrice.slice(3).replace('.', ''))) {
                comparePrice.html("De " + cPrice + ", por");
              } else {
                comparePrice.html('')
              }

              regularPrice.html( rPrice );
            
              var splitPrice = Number(rPrice.substring(2).replace('.', '')) / 6
              splittedPrice.html("ou 6x R$ " + splitPrice.toFixed(0));

              var variantId = $(this).find(":selected").attr("data-id");
              // $('#AddToCart')[0].onclick = () => window.cart.onClickAddProduct(1, variantId)
          });
      }
  })(jQuery);
}

function setupMenu() {
  $(".menu-caller").click(() => {
    $(".drawer-menu-wrapper").toggleClass("open");
    $("body").toggleClass("no-scroll");
    $(".about-overlay").toggleClass("cart__overlay--hidden");
    $(".drawer-about").removeClass("open");
  });
}

function colorSelectorsFunc() {
    const colorSelectors = document.querySelectorAll('.color-selector');
    colorSelectors.forEach(selector => {
      selector.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const url = selector.getAttribute('href');
        const response = await fetch(url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const main = document.querySelector('main');
        main.innerHTML = doc.querySelector('main').innerHTML;
        window.history.pushState({}, '', url);
        setupProductCarousel();
        colorSelectorsFunc();
        buyButton();
        setPricesVariants()
        setupMenu();
      });
    });

    window.addEventListener('popstate', async () => {
      const url = window.location.href;
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const main = document.querySelector('main');
      main.innerHTML = doc.querySelector('main').innerHTML;
      setupProductCarousel();
      colorSelectorsFunc();
      buyButton();
    });
}

function buyButton() {
    const buyButton = document.querySelector('.buy-button button');
    buyButton.addEventListener('click', async (e) => {
      e.preventDefault();
      const relatedProducts = document.querySelectorAll('.related-product input:checked');

      const data = {
        items: []
      } 

      relatedProducts.forEach(product => {
     let productVariantSelectorTitle =
  // Desktop (se existir)
  document.querySelector('.product-variant-selector')?.selectedOptions?.[0]?.querySelector('.variant-title')?.textContent
  // Fallback 1: select de opções (ex.: King)
  || document.querySelector('select[name^="options["]')?.value
  // Fallback 2: radio/pill
  || document.querySelector('input[name^="options["]:checked')?.value
  // Fallback 3: o próprio select de id (às vezes tem o título)
  || document.querySelector('select[name="id"]')?.selectedOptions?.[0]?.textContent
  || '';

productVariantSelectorTitle = productVariantSelectorTitle
  .toLowerCase()
  .trim()
  .replace(/\s+/g, '-')      // espaços múltiplos
  .replace(/[^\w-]+/g, '');
        
   let productVariantId = product.getAttribute('data-related-product-id');

const exactAttr = `data-related-product-id-${productVariantSelectorTitle}`;
if (product.hasAttribute(exactAttr)) {
  productVariantId = product.getAttribute(exactAttr);
} else {
  // fallback inteligente: procura qualquer atributo que comece com data-related-product-id-king-
  const pref = Array.from(product.attributes).find(a =>
    a.name.startsWith(`${exactAttr}-`)
  );
  if (pref?.value) productVariantId = pref.value;
}

        data.items.push({
         id: Number(productVariantId),
          quantity: 1
        });
      });
  
      data.items.push({
        id: document.querySelector('select[name="id"]').value,
        quantity: 1
      });
  
      window.cart.onClickAddProducts(data)
    });
}

document.addEventListener('DOMContentLoaded', function() {
    setupProductCarousel();
    colorSelectorsFunc();
    buyButton();
});
